<template>
  <div>
    <v-data-table
      :mobile-breakpoint="0"
      ref="theDataTable"
      :headers="tabledataProp.headersData"
      :items="tabledataProp.operatorsData"
      :search="tabledataProp.search"
      :items-per-page="5"
      class="elevation-1"
      @pagination="tabledataProp.pagination = $event"
    >
      <template v-slot:top>
        <v-toolbar flat>
          <v-row>
            <v-col cols="12" sm="6" md="4">
              <v-text-field
                v-model="tabledataProp.search"
                append-icon="mdi-magnify"
                label="Search"
                single-line
                hide-details
              ></v-text-field>
            </v-col>
          </v-row>
          <v-spacer></v-spacer>
          <v-menu
            v-model="menu"
            :close-on-content-click="false"
            :nudge-width="50"
            offset-x
          >
            <template v-slot:activator="{ on, attrs }">
              <v-btn
                class=""
                fab
                small
                color="#0C479D"
                v-bind="attrs"
                v-on="on"
              >
                <v-icon class="icon-white">icon-download</v-icon>
              </v-btn>
            </template>

            <v-card>
              <v-divider></v-divider>

              <v-list>
                <v-list-item>
                  <v-list-item-action>
                    <vue-json-to-csv
                      :json-data="tabledataProp.dataDownload"
                      :csv-title="tabledataProp.savingFilename"
                    >
                      <v-btn color="indigo" dark style="" >
                        CSV
                      </v-btn>
                    </vue-json-to-csv>
                  </v-list-item-action>
                </v-list-item>

                <v-list-item>
                  <v-list-item-action>
                    <v-btn @click="createPDF" color="indigo" dark>PDF </v-btn>
                  </v-list-item-action>
                </v-list-item>
              </v-list>
            </v-card>
          </v-menu>
        </v-toolbar>
      </template>
    </v-data-table>
  </div>
</template>

<script>
import jsPDF from "jspdf";
import "jspdf-autotable";
import { PDFDocument } from "pdf-lib";

import VueJsonToCsv from "vue-json-to-csv";
export default {
  components: {
    VueJsonToCsv,
  },
  props: ["tabledataProp"],
  data: () => {
    return {
      menu: false,
      key: 0,
      headersData: [],
      operatorsData: [],
      search: "",
      pagination: null,
      dataDownload: [],
    };
  },

  methods: {
    createPDF() {
      console.log(this.tabledataProp);
      let content = this.$refs["theDataTable"];
      let doc = new jsPDF("latitude");

      doc.text(14, 7.5, "Events Audit");
      doc.addImage(
        this.getImgUrl1(this.$config.image_inside_pdf),
        "png",
        this.$config.first_dimension_separate_again,
        this.$config.second_dimension_separate,
        this.$config.third_dimension_separate,
        this.$config.fourth_dimension_separate_again
      );

      let rows = [];
      content.items.forEach((data, index) => {
        if (
          index >= this.tabledataProp.pagination.pageStart &&
          index < this.tabledataProp.pagination.pageStop
        ) {
          let tempRow = [];
          for (let i = 0; i < this.tabledataProp.tempRow.length; i++) {
            tempRow.push(data[this.tabledataProp.tempRow[i]]);
          }

          rows.push(tempRow);
        }
      });
      console.log("checkign temp row=>", rows);
      doc.setFontSize(9);
      console.log("doc", doc, this.tabledataProp.columnHeaders, rows);
      doc.autoTable({
        head: [this.tabledataProp.columnHeaders],
        body: rows,
        startY: 11.5,
        theme: "grid",

        headStyles: {
          fillColor: [12, 71, 157],
          textColor: 255,
          fontStyle: "bold",
        },
        bodyStyles: {
          fillColor: [ 244, 244, 244],
          textColor: 0,
        },

      });      let d = new Date();
      const fileName = `${this.tabledataProp.savingFilename} ${d.toISOString().slice(0, 10) +
          " " +
          d
            .toTimeString()
            .split("(")[0]
            .slice(0, -1)}.pdf`;

      // Opt-in post-processing (e.g. Audit Log Report): shift/crop the page
      // content and fit every page onto an A4 portrait page before download.
      if (this.tabledataProp.pdfFitA4Portrait) {
        this.postProcessPdf(doc.output("arraybuffer"), this.tabledataProp.pdfExtraSpace)
          .then((bytes) => this.downloadBytes(bytes, fileName))
          .catch((err) => {
            console.error("PDF post-processing failed, saving original", err);
            doc.save(fileName);
          });
        return;
      }
      doc.save(fileName);
    },

    // Port of the two Python steps (PyPDF2 shift + PyMuPDF A4 fit).
    // Step 1: new page height = h + extraSpace, original content translated by
    //   extraSpace on Y (extraSpace = -15 crops 15pt off the bottom).
    // Step 2: scale the result to fit A4 portrait (no distortion) and center it.
    async postProcessPdf(inputBytes, extraSpace = -15) {
      const A4_W = 595;
      const A4_H = 842;
      const src = await PDFDocument.load(inputBytes);
      const out = await PDFDocument.create();

      for (const page of src.getPages()) {
        const { width, height } = page.getSize();

        // Step 1: region of the original page that remains visible.
        const box = { left: 0, right: width, bottom: -extraSpace, top: height };
        const embedded = await out.embedPage(page, box);
        const w1 = width;
        const h1 = height + extraSpace;

        // Step 2: fit inside A4 portrait, centered.
        const scale = Math.min(A4_W / w1, A4_H / h1);
        const newW = w1 * scale;
        const newH = h1 * scale;
        const a4 = out.addPage([A4_W, A4_H]);
        a4.drawPage(embedded, {
          x: (A4_W - newW) / 2,
          y: (A4_H - newH) / 2,
          width: newW,
          height: newH,
        });
      }
      return out.save();
    },

    downloadBytes(bytes, fileName) {
      const blob = new Blob([bytes], { type: "application/pdf" });
      const url = URL.createObjectURL(blob);
      const a = document.createElement("a");
      a.href = url;
      a.download = fileName;
      document.body.appendChild(a);
      a.click();
      document.body.removeChild(a);
      setTimeout(() => URL.revokeObjectURL(url), 1000);
    },
  },
};
</script>
